import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MassiveChangesEditComponent } from './massive-changes-edit.component';
import { MassivePaymentsModule } from './massive-payments/massive-payments.module';
import { MassiveOffertModule } from './massive-offert/massive-offert.module';
import { MassiveBillingModule } from './massive-billing/massive-billing.module';
import { MassiveAdminPaymentModule } from './massive-admin-payment/massive-admin-payment.module';

@NgModule({
  imports: [
    CommonModule,
    MassivePaymentsModule,
    MassiveOffertModule,
    MassiveBillingModule,
    MassiveAdminPaymentModule
  ],
  declarations: [MassiveChangesEditComponent],
  exports: [MassiveChangesEditComponent]
})
export class MassiveChangesEditModule { }
